import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Table, Panel, IconButton, Icon, Message, Row, ButtonGroup } from 'rsuite'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import pathname from '../../constants/pathname'
import { deleteReviewHistoryMulti, getReviewHistoryMulti } from '../../redux/actions/multiReview'
import { doneLoading, startLoading } from '../../utils/loading'
import ConfirmWidget from '../../widgets/confirm/ConfirmWidget'
import DashboradToggle from '../dashboard/DashboradToggle'

export default function ReviewGroupDataTable({
  shaded = true,
  bordered = true,
  config,
  onSettingChange = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [error, setError] = useState()
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [schema, setSchema] = useState()
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [deleteId, setDeleteId] = useState()

  const [expandedPanel, setExpandedPanel] = useState(true)

  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ]

  let history = useHistory()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handleReload(displayLength, page)
    }
  }, [])

  const handleReload = async (pagesize, pagenumber) => {
    setLoading(true)
    startLoading()
    try {
      const response = await getReviewHistoryMulti(pagesize, pagenumber)

      setSchema(response)
    } catch (e) {
      console.log('e', e)
      setError('เกิดข้อผิดพลาดดึงข้อมุลไม่สำเร็จ')
    }
    doneLoading()
    setLoading(false)
  }

  const handleDeleteGroup = async () => {
    setIsShowConfirmDelete(false)
    setLoading(true)
    startLoading()
    try {
      const request = {
        projectReviewGroupId: deleteId,
        pageSize: displayLength,
        pageNumber: page,
      }

      const response = await deleteReviewHistoryMulti(request)
      setSchema(response.model)
      // handleReload(displayLength, page)
    } catch (e) {
      console.log('e', e)
      setError(`ลบ${schema.header}ไม่สำเร็จ`)
    }
    doneLoading()
    setLoading(false)
  }

  const onSelected = (data) => {
    //console.log('handleAction', data)
    sessionStorage.setItem('mutiReview', data.projectIds)

    sessionStorage.setItem('projectId', data.id)
    sessionStorage.setItem('param', '')

    if (data.status == '3') {
      history.push(`${pathname.proposal.review.scrutinizeMethodMuti}`)
    } else {
      history.push(`${pathname.proposal.review.paymentSaveMulti}`)
    }
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    handleReload(dataKey, 1)
  }
  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    handleReload(displayLength, dataKey)
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <Panel
            header={schema.header}
            bordered={bordered}
            collapsible
            defaultExpanded={schema?.values?.length > 0 && expandedPanel}
            shaded={shaded}
            onClick={() => {
              setExpandedPanel(!expandedPanel)
            }}
            style={{ marginTop: 15 }}
          >
            {error && (
              <Message
                closable
                showIcon
                type="error"
                description={error}
                onClose={() => setError()}
              />
            )}

            <Table
              wordWrap
              autoHeight={config}
              height={400}
              loading={loading}
              data={schema.values || []}
            >
              <Column width={80} align="center">
                <HeaderCell>
                  <span>ลำดับ</span>
                </HeaderCell>
                <Cell>
                  {(_, index) => {
                    return index + 1 + (page * displayLength - displayLength)
                  }}
                </Cell>
              </Column>
              <Column width={160} align="center">
                <HeaderCell>
                  <span>วันที่ทำรายการ</span>
                </HeaderCell>
                <Cell dataKey="createDate" />
              </Column>
              <Column width={130} align="center">
                <HeaderCell>
                  <span>จำนวนโครงการ</span>
                </HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.projectIds?.length || 0
                  }}
                </Cell>
              </Column>
              {/* <Column width={160} align="center">
              <HeaderCell>
                <span>วิธีการกลั่นกรอง</span>
              </HeaderCell>
              <Cell dataKey="reviewMethod" />
            </Column> */}
              <Column width={200}>
                <HeaderCell>
                  <span>สถานะ</span>
                </HeaderCell>
                <Cell dataKey="statusMsg" />
              </Column>
              <Column minWidth={200} width={200} flexGrow={1}>
                <HeaderCell>
                  <span>ชื่อการจัดประชุม</span>
                </HeaderCell>
                <Cell dataKey="meetingName" />
              </Column>
              <Column width={160} align="center">
                <HeaderCell>
                  <span>วันที่จัดประชุม</span>
                </HeaderCell>
                <Cell dataKey="meetingDate" />
              </Column>
              <Column width={200} align="center" fixed="right">
                <HeaderCell align="center"></HeaderCell>
                <Cell>
                  {(rowData) => {
                    return (
                      <ButtonGroup>
                        <IconButton
                          appearance="ghost"
                          icon={<Icon icon={'eye'} className="bt-gost-icon-radius" />}
                          onClick={() => {
                            onSelected(rowData)
                          }}
                          disabled={config && true}
                        >
                          แสดง
                        </IconButton>
                        <IconButton
                          appearance="ghost"
                          disabled={!rowData.enableDelete || (config && true)}
                          icon={<Icon icon={'trash-o'} className="bt-gost-icon-none-radius" />}
                          onClick={() => {
                            setIsShowConfirmDelete(true)
                            setDeleteId(rowData.id)
                          }}
                        >
                          ลบ
                        </IconButton>
                      </ButtonGroup>
                    )
                  }}
                </Cell>
              </Column>
            </Table>

            <TablePagination
              lengthMenu={defaultLengthMenu}
              activePage={page || defaultPage}
              renderLengthMenu={(lengthMenu) => {
                return (
                  <>
                    {lengthMenu}
                    {`รายการ/หน้า`}
                  </>
                )
              }}
              renderTotal={(total) => {
                return <>{` ทั้งหมด ${total} รายการ`}</>
              }}
              displayLength={displayLength || 5}
              total={schema.totalSize}
              onChangePage={handleChangePage}
              onChangeLength={handleChangeLength}
            />

            <ConfirmWidget
              title={`ยืนยันการลบ`}
              show={isShowConfirmDelete}
              detail={`ยืนยันการลบ ${schema.header}`}
              onCancle={() => {
                setIsShowConfirmDelete(false)
                setDeleteId('')
              }}
              onConfirm={() => handleDeleteGroup()}
            />
          </Panel>
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'รายการกลั่นกรองหลายโครงการ',
  totalSize: 1,
  values: [
    {
      id: '',
      numberOfSequence: 1,
      createDate: 'DD/MM/YYYY',
      projectIds: ['', ''],
      reviewMethod: null,
      meetingName: 'ประชุม',
      meetingDate: 'DD/MM/YYYY',
      enableDelete: true,
      status: '4',
      statusMsg: 'สถานะ XXXXX',
    },
  ],
}
